module.exports = "https://r.zoocdn.com/_next/static/images/signature2021-c1093b04f956731cb564b3f7776d87cf.png";